module.exports = __webpack_public_path__ + "static/img/haos-game-lucre-games-gameplay-1.f62f18f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/haos/haos-game-lucre-games-gameplay-1.gif
// module id = qWhF
// module chunks = 0